import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const TokenExpiryWarningModal = ({
    show,
    onHide,
    timeUntilExpiry,
    formatTimeLeft,
    onExtendSession,
    onLogout
}) => {
    const { logout } = useAuth();

    const handleExtendSession = async () => {
        const result = await onExtendSession();
        if (result.success) {
            onHide();
        }
    };

    const handleLogout = async () => {
        onHide();
        await logout();
        if (onLogout) onLogout();
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            backdrop="static"
            keyboard={false}
            centered
            size="md"
        >
            <Modal.Header closeButton={false} className="bg-warning text-dark">
                <Modal.Title>
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    Session Expiring Soon
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant="warning" className="mb-3">
                    <div className="d-flex align-items-center">
                        <i className="fas fa-clock me-2 fs-4"></i>
                        <div>
                            <strong>Your session will expire in {formatTimeLeft}</strong>
                            <br />
                            <small className="text-muted">
                                You will be automatically logged out to protect your account security.
                            </small>
                        </div>
                    </div>
                </Alert>

                <div className="text-center">
                    <p className="mb-3">
                        What would you like to do?
                    </p>

                    <div className="d-grid gap-2">
                        <Button
                            variant="primary"
                            onClick={handleExtendSession}
                            className="mb-2"
                        >
                            <i className="fas fa-refresh me-2"></i>
                            Continue Session
                        </Button>

                        <Button
                            variant="outline-secondary"
                            onClick={handleLogout}
                        >
                            <i className="fas fa-sign-out-alt me-2"></i>
                            Logout Now
                        </Button>

                        <Button
                            variant="link"
                            onClick={onHide}
                            className="text-muted"
                            size="sm"
                        >
                            Dismiss Warning
                        </Button>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center bg-light">
                <small className="text-muted">
                    <i className="fas fa-info-circle me-1"></i>
                    For your security, sessions automatically expire after a period of inactivity
                </small>
            </Modal.Footer>
        </Modal>
    );
};

export default TokenExpiryWarningModal;